import { Container, Button } from "react-bootstrap";
import About from "../components/about/About";
import Offers from "./offers";
import Contact from "../components/Contact/Contact";
import CardList from "../components/CardList/cardList";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { getMenuItemsRealtime } from "../utils/functionFirebase";
import { FaPercent, FaTags } from "react-icons/fa";

function OffersPreview() {
  const [offers, setOffers] = useState([]);
  useEffect(() => {
    const unsubscribe = getMenuItemsRealtime((result) => {
      if (result.success) {
        setOffers(result.data.filter(item => item.section === "offers").slice(0, 3));
      }
    });
    return () => { if (unsubscribe) unsubscribe(); };
  }, []);
  return (
    <div className="py-5">
      <div className="text-center mb-4">
        <h2 className="fw-bold" style={{ color: "#ff3e3e", letterSpacing: 2 }}>
          أقوى العروض والخصومات
        </h2>
        <p className="fs-5 text-muted">لا تفوت الفرصة! عروض لفترة محدودة فقط</p>
      </div>
      <div className="row gy-5">
        {offers.map((offer) => (
          <div className="col-md-6 col-lg-4" key={offer.id}>
            <div className="offer-card shadow-lg position-relative" style={{overflow:'hidden'}}>
              <div className="disCount">
                <span style={{marginLeft:6}}><FaPercent /></span>
                خصم
              </div>
              <div className="image-container position-relative" style={{padding:0}}>
                <img
                  src={offer.imgUrl || offer.img}
                  alt={offer.title || offer.name}
                  className="img-item"
                  style={{filter:'brightness(0.85)'}}
                />
                {/* طبقة متدرجة للكلام فوق الصورة */}
                <div style={{
                  position:'absolute',
                  left:0,
                  bottom:0,
                  width:'100%',
                  minHeight:'110px',
                  background:'linear-gradient(0deg, rgba(0,0,0,0.85) 70%, rgba(0,0,0,0.0) 100%)',
                  color:'#fff',
                  display:'flex',
                  flexDirection:'column',
                  justifyContent:'flex-end',
                  padding:'28px 18px 16px 18px',
                  borderBottomLeftRadius:12,
                  borderBottomRightRadius:12,
                }}>
                  <div style={{fontSize:22, fontWeight:'bold', marginBottom:6, display:'flex',alignItems:'center', textShadow:'0 2px 8px #000, 0 1px 2px #222'}}>
                    <span style={{marginLeft:8, fontSize:20}}><FaTags /></span>
                    {offer.title || offer.name}
                  </div>
                  <div style={{fontSize:15, color:'#e0e0e0', minHeight:32, marginBottom:6, textShadow:'0 2px 8px #000, 0 1px 2px #222'}}>
                    {offer.description || offer.desc}
                  </div>
                  <div className="d-flex align-items-center justify-content-between mt-2">
                    <span className="text-muted text-decoration-line-through fs-6" style={{color:'#ffbdbd', fontWeight:'bold', textShadow:'0 2px 8px #000, 0 1px 2px #222'}}>
                      {offer.oldPrice} د.أ
                    </span>
                    <span className="fw-bold fs-4 offer-price" style={{color:'#1dbf73', fontWeight:'bold', textShadow:'0 2px 8px #000, 0 1px 2px #222'}}>
                      {offer.newPrice || offer.price} د.أ
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="text-center mt-4">
        <Link to="/offers" className="custom-btn btn-view-more p-2 text-decoration-none">
          عرض المزيد
        </Link>
      </div>
    </div>
  );
}

export default function Home() {
  const visibleCount = 8;

  return (
    <Container>
      <About />
<div>
  <div className="text-center mb-4">

      <h2 className="text-center my-4 section-title">قائمة الطعام</h2>
      <CardList visibleCount={visibleCount} />
</div>
      <div className="text-center mt-4">
       <Link to="/menu" className="custom-btn btn-view-more p-2 text-decoration-none">
  عرض المزيد
</Link>
      </div>
</div>
      <OffersPreview/>
      <Contact />

    </Container>
  );
}
